import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {DomainUrlService} from '../../../application/config/domain-url.service';
import {AvailableWidget} from '../model/available-widget';
import {Observable} from 'rxjs';
import {WidgetName} from '../model/widget-name.enum';
import {WidgetSize} from '../model/widget-size.enum';
import {WidgetDetail} from '../model/widget-detail';

@Injectable({
              providedIn: 'root'
            })
export class WidgetService {

  readonly WIDGET_URL = this.domainUrlService.getOptimPortalBackApiUrl() + '/rest/public/v1/widget';

  updateWidgetsSubject: EventEmitter<WidgetDetail> = new EventEmitter<WidgetDetail>();

  constructor(private httpClient: HttpClient,
              private domainUrlService: DomainUrlService) {
  }

  public getAvailableWidgetForUser(): Observable<Array<AvailableWidget>> {
    return this.httpClient.get<Array<AvailableWidget>>(`${this.WIDGET_URL}/available`) as Observable<Array<AvailableWidget>>;
  }

  public retrieveWidgetData(widgetName: WidgetName, size: WidgetSize, isMocked: boolean): Observable<any> {
    const params = new HttpParams().set('mocked', `${isMocked}`);
    return this.httpClient.get(`${this.WIDGET_URL}/${widgetName}/${size}`, {params}) as Observable<any>;
  }

  public addWidget(dashboardId: number, widgetName: WidgetName, size: WidgetSize): Observable<WidgetDetail> {
    return this.httpClient.put<any>(`${this.WIDGET_URL}/${dashboardId}/${widgetName}/${size}`, {}) as Observable<WidgetDetail>;
  }

  public removeWidget(dashboardId: number, widgetId: string): Observable<boolean> {
    return this.httpClient.delete(`${this.WIDGET_URL}/${dashboardId}/${widgetId}`) as Observable<boolean>;
  }

}
